/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationPreferenceTypeEnum } from './NotificationPreferenceTypeEnum';
import {
    NotificationPreferenceTypeEnumFromJSON,
    NotificationPreferenceTypeEnumFromJSONTyped,
    NotificationPreferenceTypeEnumToJSON,
    NotificationPreferenceTypeEnumToJSONTyped,
} from './NotificationPreferenceTypeEnum';

/**
 * A notification preference response
 * @export
 * @interface NotificationPreferenceResponse
 */
export interface NotificationPreferenceResponse {
    /**
     * UUID of the notification preference
     * @type {string}
     * @memberof NotificationPreferenceResponse
     */
    uuid: string;
    /**
     * 
     * @type {NotificationPreferenceTypeEnum}
     * @memberof NotificationPreferenceResponse
     */
    type: NotificationPreferenceTypeEnum;
    /**
     * Value of the notification preference
     * @type {string}
     * @memberof NotificationPreferenceResponse
     */
    value: string;
    /**
     * If the notification is active or not
     * @type {boolean}
     * @memberof NotificationPreferenceResponse
     */
    active: boolean;
}



/**
 * Check if a given object implements the NotificationPreferenceResponse interface.
 */
export function instanceOfNotificationPreferenceResponse(value: object): value is NotificationPreferenceResponse {
    if (!('uuid' in value) || value['uuid'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function NotificationPreferenceResponseFromJSON(json: any): NotificationPreferenceResponse {
    return NotificationPreferenceResponseFromJSONTyped(json, false);
}

export function NotificationPreferenceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationPreferenceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'uuid': json['uuid'],
        'type': NotificationPreferenceTypeEnumFromJSON(json['type']),
        'value': json['value'],
        'active': json['active'],
    };
}

export function NotificationPreferenceResponseToJSON(json: any): NotificationPreferenceResponse {
    return NotificationPreferenceResponseToJSONTyped(json, false);
}

export function NotificationPreferenceResponseToJSONTyped(value?: NotificationPreferenceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uuid': value['uuid'],
        'type': NotificationPreferenceTypeEnumToJSON(value['type']),
        'value': value['value'],
        'active': value['active'],
    };
}

